import heroImg from '../assets/hero2.jpg';
import heroMobileImg from '../assets/herosumaho.jpg';
import logoImg from '../assets/NAGARA_containerlogo.png';

function Hero() {
  return (
    <section
      className="hero"
      style={{
        '--hero-desktop-image': `url(${heroImg})`,
        '--hero-mobile-image': `url(${heroMobileImg})`,
      }}
    >
      <div className="hero-inner">
        <p className="hero-eyebrow">名古屋から全国へ</p>

        <img
          src={logoImg}
          alt="NAGARA container"
          className="hero-logo"
        />

        <h1 className="hero-mobile-title">NAGARA container</h1>

        <div className="hero-copy">
          <p className="hero-sub">海上用コンテナ・中古コンテナ販売を格安で販売！</p>
          <p className="hero-sub">豊富な品揃えで、東海NO.1!! 全国輸送可能</p>
        </div>
        <div className="hero-actions">
          <button
            className="cta-btn"
            onClick={() => {
              const el = document.getElementById('contact');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            まずは相談してみる
          </button>
          <button
            className="cta-btn cta-btn--ghost"
            onClick={() => {
              const el = document.getElementById('contact');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            資料請求
          </button>
        </div>
      </div>

      <div className="scroll-indicator">
        <span className="scroll-arrow">↓</span>
      </div>
    </section>
  );
}

export default Hero;
